import { useNavigate } from "react-router-dom";
import { useTranslation } from "@repo/core";
import { HiPlus } from "react-icons/hi";

interface OverviewHeaderProps {
  className?: string;
}

/**
 * Header component for the Overview page
 * Contains the page title and New Strategy button
 */
export const OverviewHeader = ({ className = "" }: OverviewHeaderProps) => {
  const navigate = useNavigate();
  const { tOverview } = useTranslation();

  const handleNewStrategy = () => {
    navigate("/factor-mimicking");
  };

  return (
    <div className={`flex-shrink-0 ${className}`}>
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-3xl font-bold text-gray-900">{tOverview("title")}</h1>

        {/* `h-9` == text-3xl's line-height (2.25rem), so the button matches
            the title's height exactly regardless of its own text size. */}
        <button
          onClick={handleNewStrategy}
          className="flex h-9 shrink-0 items-center gap-2 rounded-lg border px-4 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 transition-all duration-200 hover:shadow-md hover:scale-105 cursor-pointer"
          style={{
            backgroundColor: "#EBF5FF",
            borderColor: "#A4CAFE",
            color: "#1A55DB",
          }}
          aria-label={tOverview("newStrategy")}
          data-tour="new-strategy-button"
        >
          <HiPlus size={16} />
          {tOverview("newStrategy")}
        </button>
      </div>

      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
        {tOverview("subtitle")}
      </p>
    </div>
  );
};

export default OverviewHeader;
